module.exports = __webpack_public_path__ + "media/images/seed_12_2020-3607541b530ff5b8acc0cb1be407bcf0.png";